import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { BusinessSelect, IBusinessSelectProps } from './BusinessSelect';

const GetBusinessListQuery = gql`
  query {
    business {
      id
      name
    }
  }
`;

export default compose<{}, IBusinessSelectProps>(
  graphql<IBusinessSelectProps, any>(GetBusinessListQuery, {
    name: 'business',
  }),
  withProps(({ business }: any) => {
    return {
      business: business.business,
    };
  }),
)(BusinessSelect);



// WEBPACK FOOTER //
// ./src/components/Others/BusinessSelect/index.ts